import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ChecklisAreatService } from "../../master-services/check-list/checklistArea.service";
import swal from "sweetalert2";
import { error } from "console";

@Component({
  selector: "check-list-component",
  templateUrl: "./check-list.component.html",
  styleUrls: ["./check-list.component.scss"],
})
export class CheckListRedComponent implements OnInit {
  checkList: any;
  checkListUserId: any;
  answerchecklist: any;
  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private ChecklisAreatService: ChecklisAreatService
  ) {
    // this.index();
    this.checkListUserId = this.rutaActiva.snapshot.params.id;
    //this.index(this.areaId);
  }
  ngOnInit() {
    console.log("Acaaa inicio componente de checklist", this.checkListUserId);
    this.getAnswerchecklist(this.checkListUserId);
  }

  getAnswerchecklist(id: any) {
    swal({
      title: "Obteniendo información...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.ChecklisAreatService.getAnswerCheckList(id)
      .then((data) => {
        const reps: any = data;
        this.answerchecklist = reps.data;
        console.log("Aca answer checklist", this.answerchecklist);
        swal.close();
      })
      .catch((error) => console.log(error));
  }

  getStatus(id: number): string {
    switch (id) {
      case 1:
        return "Cumple";
      case 2:
        return "No Cumple";
      case 3:
        return "No Aplica";
      default:
        return "Estado desconocido";
    }
  }

  generatePdf() {
    swal({
      title: "Obteniendo información...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    const updateData: any = this.answerchecklist;
    console.warn("Datos para generar PDF:", updateData);

    this.ChecklisAreatService.generatePdf(updateData)
      .then((blob: Blob) => {
        const companyName = updateData[0].company;
        const name = updateData[0].name;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;

        a.download = `Inspección_${companyName}_${name}_.pdf`;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        console.log("PDF descargado exitosamente.");
        swal.close();
      })
      .catch((error) => {
        console.error("Error al crear PDF:", error);
      });
  }

  ///////
}



// WEBPACK FOOTER //
// ./src/app/master/check-list/check-list.component.ts